import { WorkerProfileProvider } from '@worker/state/workerProfileContext';
import { WorkerProvider } from '@worker/state/workerContext';
import WorkerRoutes from '@worker/routes/WorkerRoutes';

export default function WorkerAppShell() {
  return (
    <WorkerProfileProvider>
      <WorkerProvider>
        <WorkerRoutes />
      </WorkerProvider>
    </WorkerProfileProvider>
  );
}
